// extracted by mini-css-extract-plugin
export default {"root":"TagItemControl-module__root__JJS66","tagIcon":"TagItemControl-module__tagIcon__34QAl","tagContent":"TagItemControl-module__tagContent__a83Cw"};